<div
  class="grid grid-nogutter infinite justify-content-center mt-0 relative"
  appPullToRefresh
  #ptr="appPullToRefresh"
  (refresh)="onPullToRefresh(ptr)"
>
  <div *ngIf="cacheStatus && cacheStatus !== 'NETWORK'" class="width-100 flex justify-content-center mb-1">
    <small class="text-color-secondary">
      {{ ('common.cache_status.' + (cacheStatus?.toLowerCase() || '')) | translate }}
    </small>
  </div>
  <app-virtual-list-viewport
    *ngIf="items.length"
    [items]="items"
    [trackBy]="trackByItem"
    [estimatedItemHeight]="220"
    [appendDisabled]="loading || isInitialLoading || endOfResults"
    [appendTriggerMarginPx]="1400"
    (appendRequested)="requestNextPage()"
    class="container timeline-container m-0 p-0 mb-3">
    <ng-template let-item>
      <div class="col-12 p-0 m-0 px-1 width-100" [id]="item?.id ? 'item' + item.id : null">
        <p-card *ngIf="item.isPlaceholder" styleClass="mb-2" [style]="{width: '100%'}">
          <div class="grid grid-nogutter px-1">
            <div class="col-10 flex">
              <p-skeleton shape="circle" size="2.5rem" styleClass="mr-2"></p-skeleton>
              <div class="col-10 mt-0 pt-0">
                <p-skeleton width="12rem" height="1.1rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="9rem" height="0.9rem" styleClass="mb-2"></p-skeleton>
                <p-skeleton width="16rem" height="0.9rem"></p-skeleton>
              </div>
            </div>
            <div class="col-2 flex justify-content-end align-items-start">
              <p-skeleton shape="circle" size="1.25rem"></p-skeleton>
            </div>
          </div>
        </p-card>
        <app-search-tile *ngIf="!item.isPlaceholder" [resource]="item"></app-search-tile>
      </div>
    </ng-template>
  </app-virtual-list-viewport>
  <ng-container *ngIf="loading && !isInitialLoading" [ngTemplateOutlet]="progressSpinner"></ng-container>
  <div *ngIf="!loading && !items.length && noResultsMsg && !isInitialLoading">
    <p>{{noResultsMsg}}</p>
  </div>
</div>

<ng-template #progressSpinner>
  <div class="width-100 flex justify-content-center mb-5">
    <p-progressSpinner styleClass="w-2rem h-2rem" strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s">
    </p-progressSpinner>
  </div>
</ng-template>
